import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cardInfo noselect" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "d-flex flex-row justify-content-center align-items-center" }
const _hoisted_4 = { class: "gcPriceBox d-flex flex-row justify-content-center align-items-center" }
const _hoisted_5 = { class: "d-flex flex-column text-nowrap" }
const _hoisted_6 = { class: "amount text-nowrap" }
const _hoisted_7 = { class: "d-flex flex-row justify-content-center align-items-center" }
const _hoisted_8 = ["alt", "src"]
const _hoisted_9 = { class: "bonus avatar" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = ["alt", "src"]
const _hoisted_12 = { class: "bonus" }
const _hoisted_13 = { class: "name" }
const _hoisted_14 = ["alt", "src"]
const _hoisted_15 = { class: "bonus" }
const _hoisted_16 = { class: "name" }
const _hoisted_17 = ["alt", "src"]
const _hoisted_18 = { class: "bonus" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = { class: "d-flex flex-row gap-3" }
const _hoisted_21 = { class: "amount stroke" }
const _hoisted_22 = { class: "amount discount" }
const _hoisted_23 = {
  key: 1,
  class: "amount"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", {
      class: _normalizeClass({
                white_pass: _ctx.pass.code === 'WHITE_PASS',
            }),
      style: _normalizeStyle({
                color: _ctx.pass.labelColor,
            })
    }, _toDisplayString(_ctx.pass.name), 7),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            alt: "Галакоин, галакоины",
            class: "icon",
            src: `/img/page/landing/registration/icon/galacoin.png`
          }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.pass.galacoinAmount), 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "currency" }, "галакоинов", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("img", {
              alt: _ctx.pass.avatar.name,
              class: "bonusIcon avatar",
              src: `/img/page/landing/registration/avatar/${_ctx.pass.avatar.image}/face.png`
            }, null, 8, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "type" }, "Аватар", -1)),
              _createElementVNode("div", _hoisted_10, "«" + _toDisplayString(_ctx.pass.avatar.name) + "»", 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("img", {
              alt: _ctx.pass.frame.name,
              class: "bonusIcon",
              src: `/img/faceframes/${_ctx.pass.frame.image}`
            }, null, 8, _hoisted_11),
            _createElementVNode("div", _hoisted_12, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "type" }, "Рамка", -1)),
              _createElementVNode("div", _hoisted_13, "«" + _toDisplayString(_ctx.pass.frame.name) + "»", 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("img", {
              alt: _ctx.pass.ship.name,
              class: _normalizeClass(["bonusIcon", {
                                flipped: _ctx.pass.code === 'WHITE_PASS'
                            }]),
              src: `/img/page/landing/registration/ship/${_ctx.pass.ship.image}`
            }, null, 10, _hoisted_14),
            _createElementVNode("div", _hoisted_15, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "type" }, "Голограмма", -1)),
              _createElementVNode("div", _hoisted_16, "«" + _toDisplayString(_ctx.pass.ship.name) + "»", 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("img", {
              alt: _ctx.pass.container.name,
              class: "bonusIcon",
              src: `/img/page/landing/registration/container/${_ctx.pass.container.image}.png`
            }, null, 8, _hoisted_17),
            _createElementVNode("div", _hoisted_18, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "type" }, "Контейнер", -1)),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.pass.container.name), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["gcPriceBox priceBox d-flex flex-row justify-content-center align-items-center", {
                playersChoice: _ctx.pass.isPlayersChoice,
            }])
    }, [
      _createElementVNode("div", _hoisted_20, [
        (_ctx.discountPrice !== null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.basicPrice.toLocaleString('ru').replace(/\u00A0/g, ' ')) + " ₽", 1),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.discountPrice.toLocaleString('ru').replace(/\u00A0/g, ' ')) + " ₽", 1)
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.pass.basicPrice.toLocaleString('ru').replace(/\u00A0/g, ' ')) + " ₽", 1))
      ])
    ], 2)
  ]))
}